export const NavDataConfig = [
    {
        to: 'home',
        label: 'Home',
    },
    // {
    //     to: 'benefits',
    //     label: 'Benefits',
    // },
    
    {
        to: 'features',
        label: 'Features',
    },
    {
        to: 'pricing',
        label: 'Pricing',
    },
    // {
    //     to: 'faqs',
    //     label: 'FAQs',
    // },
    {
        to: 'contact',
        label: 'Contact',
    },
]